import { create } from "apisauce"
import { toast } from "react-toastify"
import { store } from "../redux/store"
import { login, logout } from "../redux/counterSlice"
import { removeReportData } from "../redux/reportSlice"
const baseURL = process.env.REACT_APP_BASE_URL
const apiClient = create({
  baseURL: baseURL
})
const authToken = localStorage.getItem("token")
if (authToken) apiClient.setHeader("authorization", `Bearer ${authToken}`)

function setAuthToken(token) {
  if (token) apiClient.setHeader("authorization", `Bearer ${token}`)
  else apiClient.deleteHeader("authorization")
}

let currentToken = store.getState().auth.token
store.subscribe(() => {
  const token = store.getState().auth.token
  if (token !== currentToken) {
    currentToken = token
    setAuthToken(token)
  }
})

function clearSession() {
  setAuthToken(null)
  store.dispatch(logout())
  store.dispatch(removeReportData())
}

function acceptLogin(data) {
  const role = data?.data?.role
  if (typeof data?.token !== "string" || !data.token || !["AD", "SA", "TN", "PPTN", "EXP"].includes(role)) {
    return false
  }
  store.dispatch(removeReportData())
  store.dispatch(login({ token: data.token, userType: role }))
  if (data.trustedDeviceToken) localStorage.setItem("petbioTrustedDeviceToken", data.trustedDeviceToken)
  return true
}

async function logoutFromServer() {
  const response = await apiClient.post("/auth/logout", {})
  if (response.status === 204 || response.status === 401) {
    clearSession()
    return true
  }
  toast.error("Could not log out. Please check your connection and try again.")
  return false
}

apiClient.addResponseTransform(response => {
  const token = store.getState().auth.token
  const headers = response.config?.headers
  const sentToken = headers?.authorization || headers?.Authorization
  // Credential errors do not imply revocation; late responses from an old login
  // must not clear a newer login either.
  const url = response.config?.url || ""
  const credentialRequest = /\/auth\/(login|2fa\/login\/verify)(?:\?|$)/.test(url) ||
    (/\/auth\/updateMyPassword(?:\?|$)/.test(url) && response.data?.message === "Your current password is wrong.")
  if (response.status === 401 && token && sentToken === `Bearer ${token}` && !credentialRequest) {
    clearSession()
    if (!(response.config?.url || "").includes("/auth/logout")) {
      toast.error("Your session has expired or been revoked. Please sign in again.")
    }
  }
})

export { setAuthToken, clearSession, logoutFromServer, acceptLogin }
export default apiClient
